import { gql } from 'graphql-request';
import {
  LogArchive,
  Nullable,
  UserWithToken,
  WithData,
} from '@ygoargentina/sdk/api/api.types';
import { getGraphQLQueryClient } from './query-client';

export const getLogArchives = (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<LogArchive[]>>(gql`
    query logArchives {
      data: logArchives {
        date
        key
        size
        uploadedAt
      }
    }
  `);

/** El .ndjson.gz del día, en base64. */
export const getLogArchive = (user: Nullable<UserWithToken>, date: string) =>
  getGraphQLQueryClient(user).request<WithData<string>>(
    gql`
      query logArchive($date: String!) {
        data: logArchive(date: $date)
      }
    `,
    { date }
  );
